import { ar } from "./languages/ar"
import { da } from "./languages/da"
import { de } from "./languages/de"
import { en } from "./languages/en"
import { es } from "./languages/es"
import { fr } from "./languages/fr"
import { it } from "./languages/it"
import { ja } from "./languages/ja"
import { ko } from "./languages/ko"
import { pt } from "./languages/pt"

const localizations = {
  en,
  ar,
  da,
  de,
  es,
  fr,
  it,
  ja,
  ko,
  pt,
}

export default localizations
